import api from "api";
import React, { useEffect, useState, useRef } from "react";
import { usePopper } from "react-popper";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { AvatarGetPicture } from "component/Avatar";
import _ from "lodash";
import update from "immutability-helper";
import "./index.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import { Waypoint } from 'react-waypoint';
import { format, fromUnixTime, toDate  } from "date-fns";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import Sidebar from "component/Sidebar";
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';

const MessagingBoxAvatar = (props) => {
    
    return (
        <div className="avatar-horizontal avatar-horizontal-1">
            <div className="avatar-img">
                <span className="image-box square circle">
                    {
                        !props.user.UserPhoto ? <InitialsAvatar name={props.user.UserDisplayName} /> 
                        : <img src={AvatarGetPicture(props.user)} alt={ props.user.UserDisplayName } />
                    }
                </span>
            </div>
            {
                props.user.use_name && 
                <div className="avatar-identity">
                    <span className="user-name">
                        { props.user.UserDisplayName }
                    </span>
                </div>
            }
        </div>
    )
}

const MessagingBox = connect(stateMap)(props => {
    const [referenceElement, setReferenceElement]   = useState(null);
    const [popperElement, setPopperElement]         = useState(null);
    const {styles}                                  = usePopper(referenceElement, popperElement, {
        placement : 'bottom-start'
    });
    const [nameToSearch, setNameToSearch]           = useState('');
    const [availableUser, setAvailableUser]         = useState(false);
    const [showToDropDown, setShowToDropdown]       = useState(false);
    const [isSearchingTo, setIsSearchingTo]         = useState(false);
    const popperWrapper = useRef(null);

    const [chatUsers, setChatUsers]                 = useState(false);
    const [preselectUser, setPreselectUser]         = useState(props.chat_user || 0);
    const [userInChat, setUserInChat]               = useState(false);
    const [chatMessagesPage, setChatMessagesPage]   = useState(1)
    const [chatMessages, setChatMessages]           = useState(false);
    const [chatMessage, setChatMessage]             = useState('');
    const chatMessagesBoxContainer                  = useRef(null);
    const chatMessagesBox                           = useRef(null);
    const [fetchingMessage, setFetchingMessage]     = useState(false);
    let chatBoxScrollPos                            = 0;

    const SearchAvailableUser = (e) => {
        setNameToSearch(e.target.value);

        if(e.target.value.length === 0)
        {
            setAvailableUser(false);

            setShowToDropdown(false);

            return setIsSearchingTo(false);
        }

        if(e.target.value.length < 3 || isSearchingTo)
        {
            setAvailableUser(false);

            return;
        }

        setAvailableUser(false);

        setIsSearchingTo(true);

        setShowToDropdown(true);

        api('/Messaging/AvailableUsers', 'get', {
            letter : e.target.value
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsSearchingTo(false);
                setAvailableUser(response.user);
            })
            .catch(error => {
                setIsSearchingTo(false);
            })

    }

    const PutUserToTop = (user) => {
        var posIndex = _.findIndex(chatUsers, {UserID : user.UserID});
        if(posIndex >= 0)
        {
            let ReArrangeUsers = update(chatUsers, {
                $splice : [[
                    posIndex, 1
                ]]
            });

            ReArrangeUsers = update(ReArrangeUsers, {
                $unshift : [user]
            });

            setChatUsers(ReArrangeUsers);
        }
        else
        {

            setChatUsers(update(chatUsers, {
                $unshift : [user]
            }));
        }
    }

    const activateUserChat = (user) => {
        setChatMessagesPage(1);
        setChatMessages(false);
        setUserInChat(user);
        setNameToSearch('');
    }

    const SelectUserToMsg = (user) => {
        setShowToDropdown(false);
        setAvailableUser(false);

        // Is User already in chat list

        var posIndex = _.findIndex(chatUsers, {UserID : user.UserID});
        if(posIndex >= 0)
        {
            PutUserToTop(user);
        }
        else
        {
            setChatUsers(update(chatUsers, {
                $unshift : [user]
            }));
        }

        activateUserChat(user);
    }

    const BodyClick = (e) => {
        if (popperWrapper.current && !popperWrapper.current.contains(e.target)) 
        {
            setShowToDropdown(false);
        }
    }

    const SendChat = (e) => {
        e.preventDefault();

        let savingChat = popinfo('loading', 'Send Message', 'Please wait');

        api('/Messaging/message', 'post', {
            receiver : userInChat.UserID
            ,message_body : chatMessage
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                savingChat.close();
                setChatMessage('');
                setChatMessages(update(chatMessages, {
                    $unshift : [response.message]
                }));
            })
            .catch(error => {
                popinfo('error', 'Send Message', error, {}, savingChat);
            })
    }

    const LoadMessage = () => {
        if(userInChat === false)
        {
            return;
        }

        setFetchingMessage(true);

        chatBoxScrollPos = chatMessagesBox.current.offsetHeight;

        api('/Messaging/message', 'get', {
            receiver : userInChat.UserID
            ,posts_per_page : 10
            ,paged : chatMessagesPage
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                
                if(response.message.length > 0)
                {
                    setFetchingMessage(false);
    
                    if(chatMessages !== false)
                    {
                        setChatMessages( chatMessages.concat(response.message));
                    }
                    else
                    {
                        setChatMessages(response.message);
                    }
    
                    setChatMessagesPage(chatMessagesPage + 1);
    
                }
                else
                {
                    if(chatMessagesPage == 1)
                    {
                        setChatMessages([]);
                    }
    
                    setFetchingMessage('EOF');
                }

            });
    }

    useEffect(() => {
        
        api('/Messaging/users', 'get', {

        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setChatUsers(response.user);
            });

    }, []);

    useEffect(() => {
        if(chatUsers === false)
        {
            return;
        }

        if(preselectUser == 0)
        {
            return;
        }

        var UserChatIndex = _.findIndex(chatUsers, {UserID : preselectUser});

        if(UserChatIndex >= 0)
        {
            PutUserToTop(chatUsers[UserChatIndex]);
            activateUserChat(chatUsers[UserChatIndex]);
            setPreselectUser(0);
        }
        else
        {
            api('/Messaging/AvailableUsers', 'get', {
                id : preselectUser
            }, 'Bearer ' + props.auth.token)
                .then(response => {
                    PutUserToTop(response.user[0]);
                    activateUserChat(response.user[0]);
                    setPreselectUser(0);
                });
        }

        
    }, [chatUsers])

    useEffect(() => {
        document.addEventListener('click', BodyClick, true);
        return () => {
            document.removeEventListener('click', BodyClick, true);
        }
    },[]);

    useEffect(LoadMessage, [userInChat])

    useEffect(() => {   
        if(chatMessagesBoxContainer.current && chatMessagesPage == 2)
        {
            chatMessagesBoxContainer.current.scrollTop = chatMessagesBoxContainer.current.scrollHeight;
        }
        else
        {
            chatMessagesBoxContainer.current.scrollTop = chatMessagesBoxContainer.current.offsetHeight - chatBoxScrollPos;
        }

    }, [chatMessagesPage])

    return (
        <div className="messaging-box border-solid rounded">
            <div className="messaging-box-wrapper">
                <Sidebar>
                    <div>
                        <div className="message-users-heading">
                            Messages
                        </div>
                        <div className="conversation-list">
                            {
                                preselectUser === 0 && chatUsers !== false && 
                                <div className="send-message-box generic-form" ref={popperWrapper}>
                                    <input 
                                        type="text" 
                                        ref={setReferenceElement} 
                                        className="form-control text" 
                                        placeholder="Find user to message.."
                                        value={nameToSearch} 
                                        onChange={SearchAvailableUser} />
                                    {
                                        showToDropDown && 
                                        <div className="user-to-dropdown" ref={setPopperElement} style={_.assignIn({}, styles.popper, {
                                            
                                        }) }>
                                            {
                                                (isSearchingTo || (availableUser !== false && availableUser.length > 0)) && 
                                                <ul className="users">
                                                    {
                                                        !isSearchingTo && availableUser !== false && availableUser.map(user => (
                                                            <li className="user" key={user.UserID}>
                                                                <div className="user-to relative" onClick={() => {SelectUserToMsg(user)}}>
                                                                    <div className="avatar-picture">
                                                                        <MessagingBoxAvatar user={_.assignIn({}, user, {

                                                                        })}/>
                                                                    </div>
                                                                    <div className="avatar-name">
                                                                        <span className="user-name">{user.UserDisplayName}</span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {
                                                        isSearchingTo &&
                                                        <li className="user user-skeleton">
                                                            <span className="skeleton"></span>
                                                        </li>
                                                    }
                                                </ul>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <ul className="users users-past-conversation">
                                {
                                    preselectUser === 0 && chatUsers !== false && chatUsers.map(user => (
                                        
                                        <li className={`user ${user.UserID == userInChat.UserID && 'active'}`} key={user.UserID}>
                                            <div className="user-to relative" onClick={e => {
                                                e.preventDefault();
                
                                                activateUserChat(user);
                                            }}>
                                                <div className="avatar-picture">
                                                    <MessagingBoxAvatar user={_.assignIn({}, user, {

                                                    })}/>
                                                </div>
                                                <div className="avatar-name">
                                                    <span className="user-name">{user.UserDisplayName}</span>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                }
                                {
                                    (preselectUser !== 0 || chatUsers === false) &&
                                    <li className="user user-skeleton">
                                        <span className="skeleton"></span>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </Sidebar>
                <div className="messages-box">
                    {
                        userInChat && 
                        <div className="user-to-chat-header">
                            <MessagingBoxAvatar user={_.assignIn({}, userInChat, {
                                use_name : true
                            })}/>
                        </div>
                    }
                    <div className="messages-box-chat-list-wrapper" ref={chatMessagesBoxContainer}>
                        <ul className={`chat-lists ${userInChat && 'active-chat'}`} ref={chatMessagesBox}>
                            {
                                fetchingMessage !== 'EOF' && 
                                <li className="chat-list">
                                    <Waypoint onEnter={() => {
                                        if(chatMessagesPage > 1)
                                        {
                                            LoadMessage();
                                        }
                                    }}/>
                                </li>
                            }
                            {
                                userInChat && fetchingMessage === true &&
                                <li className="chat-list">
                                    <span className="skeleton"></span>
                                </li>
                            }
                            {
                                userInChat && chatMessages !== false && chatMessages.length == 0 && 
                                <li className="chat-list">
                                    <div className="text-center text-sm bold" style={{padding:'30px 0'}}>
                                        Start send message to {userInChat.UserDisplayName}
                                    </div>
                                </li>
                            }
                            {
                                userInChat && chatMessages !== false && [...chatMessages].reverse().map(chat => {
                                    return (
                                        <li className={`chat-list ${chat.FromID === props.auth.user.UserID && 'my-message' } `} key={chat.MessageID}>
                                            <div className="chat-list-wrapper">
                                                <div className="message-sender">
                                                    <MessagingBoxAvatar user={_.assignIn({}, chat, {
                                                        use_name : true
                                                    })}/>
                                                </div>
                                                <div className="message-body leading-text" dangerouslySetInnerHTML={{__html : chat.MesssageBody}}></div>
                                                <div className="text-right mt-lg text-xs">
                                                    {format(utcToZonedTime(fromUnixTime(chat.SendTime), 'UTC'), 'dd LLLL Y HH:mm:ss', { timeZone: 'UTC+0' })}
                                                </div>
                                            </div>
                                        </li>
                                    )
                                    } 
                                )
                            }
                        </ul>
                    </div>
                    {
                        userInChat && 
                        <form className="chat-message-form generic-form" onSubmit={SendChat}>
                            <textarea  
                                cols="30" 
                                rows="3" 
                                className="form-control textarea leading-text" 
                                value={chatMessage}
                                placeholder="Type your message.."
                                onChange={(e) => {
                                    setChatMessage(e.target.value);
                            }}></textarea>
                            <div className="text-right">
                                <input type="submit" value="Send" className="btn btn-orange btn-small" />
                            </div>
                        </form>
                    }
                    {
                        !userInChat &&
                        <div className="message-box-empty ">
                            Choose from a list of previous conversations or start a new conversation by typing someone else's name
                        </div>
                    }
                </div>
            </div>
        </div>
    )
})

export {MessagingBox}